























































































































































import Vue from 'vue';
import Component from 'vue-class-component';


enum Role {
  Operator,
  Scanner,
  Supressor
}

enum SecuritySide {
  Light,
  Dark
}

enum AtraksPlatform {
  Ground,
  Space
}

class Guardian {
  key = -1;
  name  = '';
  role: Role | null = null;
  side: SecuritySide | null = null;
  platform: AtraksPlatform | null = null;
  isPrimary = false;

  constructor (options?: {key: number; name: string}) {
    if (options) {
      this.key = options.key;
      this.name = options.name;
    }
  }
}

@Component({ components: {} })
export default class PartyMaker extends Vue {
  encounters: string[] =  ['Security', 'Atraks', 'Taniks'];
  guardians: Array<Guardian> = [
    new Guardian({key: 0, name: ''}),
    new Guardian({key: 1, name: ''}),
    new Guardian({key: 2, name: ''}),
    new Guardian({key: 3, name: ''}),
    new Guardian({key: 4, name: ''}),
    new Guardian({key: 5, name: ''}),
  ]

  chosenEncounter = 'Security';
  assignRoles = false;
  teamsMade = false;

  getLightTeam() {
      return this.guardians.filter(a => a.side === SecuritySide.Light);
  }

  getDarkTeam() {
    return this.guardians.filter(a => a.side === SecuritySide.Dark);
  }

  getGroundTeam() {
    return this.guardians.filter(a => a.platform === AtraksPlatform.Ground);
  }

  getSpaceTeam() {
    return this.guardians.filter(a => a.platform === AtraksPlatform.Space)
  }

  getOperators() {
    return this.guardians.filter(a => a.role === Role.Operator).sort(a => a.isPrimary ? -1 : 1);
  }

  getScanners () {
    return this.guardians.filter(a => a.role === Role.Scanner).sort(a => a.isPrimary ? -1 : 1);
  }

  getSuppressors() {
    return this.guardians.filter(a => a.role === Role.Supressor).sort(a => a.isPrimary ? -1 : 1);
  }

  getRoleIcon(guardian: Guardian) {
    if (guardian.role === null) {
      return '';
    }
    if (guardian.role === Role.Operator) {
      return require('../assets/tomato.png');
    }
    if (guardian.role === Role.Scanner) {
      return require('../assets/lemon.png');
    }
    if (guardian.role === Role.Supressor) {
      return require('../assets/blueberries.png');
    }

    return '';
  }

  isOperator(guardian: Guardian) {
    return guardian.role == Role.Operator;
  }

  isScanner(guardian: Guardian) {
    return guardian.role == Role.Scanner;
  }


  isSupressor(guardian: Guardian) {
    return guardian.role == Role.Supressor;
  }


  generateTeams() {
    this.refreshGuardians();

    if (this.chosenEncounter === 'Security') {
      this.generateForSecurity();
    }
    else if (this.chosenEncounter === 'Atraks') {
      this.generateforAtraks();
    }
    else {
      this.generateForTaniks();
    }
  }

  generateForSecurity() {
    let i = 0;
    while (i < this.guardians.length) {
      const index = this.getRandomInt(this.guardians.length);
      const guardian = this.guardians[index];

      if (guardian.side !== null) {continue;}

      if (i < Math.floor(this.guardians.length / 2)) {
        guardian.side = SecuritySide.Dark;
      }
      else {
        guardian.side = SecuritySide.Light;
      }

      this.guardians[index] = guardian;
      i++;
    }

    if (this.assignRoles) {
      const lightSideGuardians = this.guardians.filter(a => a.side === SecuritySide.Light);
      const darkSideGuardians = this.guardians.filter(a => a.side === SecuritySide.Dark);

      let foundLightSideOperator = false;
      while (!foundLightSideOperator) {
        const guardian = lightSideGuardians[this.getRandomInt(lightSideGuardians.length)];

        if (guardian.role === Role.Operator) {continue;}

        guardian.role = Role.Operator;
        this.guardians[guardian.key] = guardian;
        foundLightSideOperator = true;
      }

      let foundDarkSideOperator = false;
      while (!foundDarkSideOperator) {
        const guardian = darkSideGuardians[this.getRandomInt(darkSideGuardians.length)];

        if (guardian.role === Role.Operator) {continue;}

        guardian.role = Role.Operator;
        this.guardians[guardian.key] = guardian;
        foundDarkSideOperator = true;
      }

      let foundLightScanner = false;
      while (!foundLightScanner) {
        const guardian = lightSideGuardians[this.getRandomInt(lightSideGuardians.length)];

        if (guardian.role === Role.Operator) {continue;}

        guardian.role = Role.Scanner;
        this.guardians[guardian.key] = guardian;
        foundLightScanner = true;
      }

      let foundDarkScanner = false;
      while (!foundDarkScanner) {
        const guardian = darkSideGuardians[this.getRandomInt(darkSideGuardians.length)];

        if (guardian.role === Role.Operator) {continue;}

        guardian.role = Role.Scanner;
        this.guardians[guardian.key] = guardian;
        foundDarkScanner = true;
      }
    }
    
    this.teamsMade = true;
  }

  generateforAtraks() {
    let i = 0;
    while (i < this.guardians.length) {
      const index = this.getRandomInt(this.guardians.length);
      const guardian = this.guardians[index];

      if (guardian.platform !== null) {continue;}

      if (i < Math.floor(this.guardians.length / 2)) {
        guardian.platform = AtraksPlatform.Ground;
      }
      else {
        guardian.platform = AtraksPlatform.Space;
      }

      this.guardians[index] = guardian;
      i++;
    }

    if (this.assignRoles) {
      let foundOperator = false;
      const spaceGuardians = this.guardians.filter(a => a.platform === AtraksPlatform.Space);
      while (!foundOperator) {
        const guardian = spaceGuardians[this.getRandomInt(spaceGuardians.length)];

        if (guardian.role !== Role.Operator) {
          guardian.role = Role.Operator;
          this.guardians[guardian.key] = guardian;
          foundOperator = true;
        }
      }

      let foundSpaceScanner = false;
      while (!foundSpaceScanner) {
        const guardian = spaceGuardians[this.getRandomInt(spaceGuardians.length)];

        if (guardian.role === Role.Operator) {continue;}

        guardian.role = Role.Scanner;
        this.guardians[guardian.key] = guardian;
        foundSpaceScanner = true;
      }

      let foundGroundScanner = false;
      const danceCrew = this.guardians.filter(a => a.platform === AtraksPlatform.Ground);
      while (!foundGroundScanner) {
        const guardian = danceCrew[this.getRandomInt(danceCrew.length)];

        if (guardian.role === Role.Operator) {continue;}

        guardian.role = Role.Scanner;
        this.guardians[guardian.key] = guardian;
        foundGroundScanner = true;
      }
    }     
    
    this.teamsMade = true;
  }

  generateForTaniks() {
    let foundPrimaryOperator=false;
    while (!foundPrimaryOperator) {
      const guardian = this.guardians[this.getRandomInt(this.guardians.length)];

      if (guardian.role !== null) { continue; }

      guardian.role = Role.Operator;
      guardian.isPrimary = true;
      foundPrimaryOperator = true;
    }

    let foundBackupOperator=false;
    while (!foundBackupOperator) {
      const guardian = this.guardians[this.getRandomInt(this.guardians.length)];

      if (guardian.role !== null) { continue; }

      guardian.role = Role.Operator;
      foundBackupOperator = true;
    }

    let foundPrimaryScanner=false;
    while (!foundPrimaryScanner) {
      const guardian = this.guardians[this.getRandomInt(this.guardians.length)];

      if (guardian.role !== null) { continue; }

      guardian.role = Role.Scanner;
      guardian.isPrimary = true;
      foundPrimaryScanner = true;
    }

    let foundBackupScanner=false;
    while (!foundBackupScanner) {
      const guardian = this.guardians[this.getRandomInt(this.guardians.length)];

      if (guardian.role !== null) { continue; }

      guardian.role = Role.Scanner;
      foundBackupScanner = true;
    }

    let foundPrimarySuppressor=false;
    while (!foundPrimarySuppressor) {
      const guardian = this.guardians[this.getRandomInt(this.guardians.length)];

      if (guardian.role !== null) { continue; }

      guardian.role = Role.Supressor;
      guardian.isPrimary = true;
      foundPrimarySuppressor = true;
    }

    let foundBackupSuppressor=false;
    while (!foundBackupSuppressor) {
      const guardian = this.guardians[this.getRandomInt(this.guardians.length)];

      if (guardian.role !== null) { continue; }

      guardian.role = Role.Supressor;
      foundBackupSuppressor = true;
    }

    this.teamsMade = true;
  }

  getRandomInt(max: number) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  refreshGuardians() {
    for (const guardian of this.guardians) {
      guardian.role = null;
      guardian.side = null;
      guardian.platform = null;
      guardian.isPrimary = false;
    }

    this.teamsMade = false;
  }
  
}

